<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path d="M9.75049 10.2564L15.0005 4.87179V2H1.00049V4.87179L6.25049 10.2564V16L9.75049 13.8462V10.2564Z" stroke="#333333" stroke-width="1.3" />
  </svg>
</template>
